import React from 'react';
import './ScheduleAvailabilityCalendarSkeleton.css';

/**
 * Skeleton loader for availability calendar
 */
const ScheduleAvailabilityCalendarSkeleton = () => {
  const SLOT_HOURS = 2;
  const SLOTS_PER_DAY = 12;
  const DAYS_COUNT = 5;
  const TOTAL_SLOTS = DAYS_COUNT * SLOTS_PER_DAY;

  return (
    <div className="sac-container">
      <table className="sac-skeleton-table">
        <thead>
          <tr>
            <th className="sac-members-col" rowSpan="2">
              <div className="sac-skeleton-header" />
            </th>
            {[...Array(DAYS_COUNT)].map((_, dayIndex) => (
              <th key={dayIndex} colSpan={SLOTS_PER_DAY}>
                <div className="sac-skeleton-day-header" />
              </th>
            ))}
          </tr>
          <tr>
            {[...Array(TOTAL_SLOTS)].map((_, slotIndex) => (
              <th key={slotIndex} className="sac-time-slot">
                <div className="sac-skeleton-time-slot" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(3)].map((_, memberIndex) => (
            <tr key={memberIndex}>
              <td className="sac-members-col">
                <div className="sac-skeleton-member-name" />
              </td>
              {[...Array(TOTAL_SLOTS)].map((_, slotIndex) => (
                <td key={slotIndex} className="sac-skeleton-slot">
                  <div className="sac-skeleton-content" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleAvailabilityCalendarSkeleton;
